/* eslint-disable no-new-func */
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';

const varResolver = (script, defaultWidgetPublicPath) => {
    const varScript = script.substring(4);
    const outer = new Function(
        'wrapper',
        'React',
        'ReactDOM',
        'PropTypes',
        '__widget_webpack_public_path__',
        `return wrapper.${varScript};\n`,
    );

    const wrapper = {};
    outer(wrapper, React, ReactDOM, PropTypes, defaultWidgetPublicPath);

    return wrapper[Object.getOwnPropertyNames(wrapper)[0]];
};

const amdResolver = (script, defaultWidgetPublicPath) => {
    let component;
    const outer = new Function(
        'define',
        '__widget_webpack_public_path__',
        `${script};\n`,
    );
    const define = (...args) => {
        let deps;
        let componentFn;

        if (args.length === 1) {
            [componentFn] = args;
        } else if (args.length === 2) {
            [deps, componentFn] = args;
        } else if (args.length === 3) {
            args.shift();
            [deps, componentFn] = args;
        }

        const dependencies = (deps || []).map((depName) => {
            if (depName === 'React' || depName === 'react') {
                return React;
            } else if (depName === 'PropTypes' || depName === 'prop-types') {
                return PropTypes;
            } else if (depName === 'ReactDOM' || depName === 'react-dom') {
                return ReactDOM;
            }

            return null;
        });

        component = componentFn.apply(this, dependencies);
    };
    define.amd = true;

    outer(define, defaultWidgetPublicPath);

    return component;
};

const commonjsResolver = (script, defaultWidgetPublicPath) => {
    let component;
    const outer = new Function(
        'module',
        'require',
        'exports',
        'React',
        'ReactDOM',
        'PropTypes',
        '__widget_webpack_public_path__',
        `${script};\n`,
    );

    const module = {};
    const exports = {};
    const require = (moduleId) => {
        switch (moduleId) {
            case 'React':
            case 'react':
                return React;
            case 'PropTypes':
            case 'prop-types':
                return PropTypes;
            case 'ReactDOM':
            case 'react-dom':
                return ReactDOM;
            default:
                return null;
        }
    };

    outer(
        module,
        require,
        exports,
        React,
        ReactDOM,
        PropTypes,
        defaultWidgetPublicPath,
    );
    component = module.exports;

    if (!component) {
        if (exports.default) {
            component = exports;
        } else {
            const exportsPropNames = Object.getOwnPropertyNames(exports);

            if (exportsPropNames.length > 0) {
                component = exports[exportsPropNames[0]];
            }
        }
    }

    return component;
};

const findResolver = (strParam) => {
    const str = strParam;

    if (!str) {
        return null;
    }

    if (str.indexOf('var ') === 0) {
        return varResolver;
    } else if (str.indexOf('define(') === 0) {
        return amdResolver;
    } else if (
        str.indexOf('module.exports=') === 0 ||
        str.indexOf('exports.') === 0 ||
        str.indexOf('exports[') === 0 ||
        str.indexOf('!function') === 0 ||
        ((str.indexOf('function _interopDefault(e)') !== -1 ||
            str.indexOf('function _interopDefaultLegacy(e)') !== -1) &&
            str.indexOf('module.exports=') !== -1)
    ) {
        return commonjsResolver;
    }

    return null;
};

export { findResolver };
export default {};
